import * as React from "react";

import { Resource } from "../Services/ResourceService";

import useAuthorizedQuery from "./useAuthorizedQuery";
import { UseCRUD } from "./hookTypes";
import { useQueryClient } from "react-query";

function useRead<T extends Resource, K extends Resource = T>({
  service,
  id,
}: UseCRUD<T>) {
  const queryClient = useQueryClient();

  const { data, isLoading: isReading } = useAuthorizedQuery(
    service.getQueryKey([id]),
    () => {
      if (id) {
        return service.fetch({ id });
      }

      throw new Error("id is required");
    },
    {
      enabled: !!id,
    }
  );

  const prefetch = React.useCallback(
    ({ id: innerId }: { id: T["id"] }) =>
      queryClient.prefetchQuery(service.getQueryKey([id]), () =>
        service.fetch({ id: innerId })
      ),
    []
  );

  return {
    data,
    prefetch,
    isReading,
  };
}

export default useRead;
